import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'submenu-icon',
  template: `
    <svg
      icon
      width="22"
      height="22"
      style="float: right"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10 17L15 12L10 7V17Z" fill="#333333" />
    </svg>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubmenuIconComponent {}
